export default {
  noGoalsDoc: {
    issues: [
      {
        id: 'I-GE-GOAL-1700',
        domain: 'DGEP'
      }
    ],
    triggerValue: true
  },
  needsHelp: {
    issues: [
      {
        id: 'I-GE-GOAL-1000',
        domain: 'DGEP',
        isDynamic: true,
        dynamicParameters: { type: 'goal' }
      }
    ],
    triggerValue: 'yes'
  }
}
